<script setup>
import Modal from "@/components/modal/Modal";
import {hospitalRecordsTabAccess, transportTabAccess, triageTabAccess} from "../../patientModal/tabs/tabsAccess";
import {computed, onMounted} from "vue";
import {PatientModalTabs} from "../../choices";

const props = defineProps({
    patient: {
        type: Object,
        required: true
    },
    member: {
        type: Object,
        required: true
    },
})
const emit = defineEmits(['close', 'displayPatientModal', 'displayTriageWizard', 'displayTransportWizard', 'displayIdentificationWizard', 'displayHospitalRecordsWizard'])

const title = computed(() => {
    const parts = [];
    if (props.patient.ticPrefix && props.patient.ticNumber) {
        parts.push(`${props.patient.ticPrefix}${props.patient.ticNumber}`);
    }
    if (props.patient.firstName || props.patient.lastName) {
        parts.push(`${props.patient.firstName} ${props.patient.lastName}`);
    }
    return parts.join(' - ');
})

function displayPatientModal(tab) {
    switch (tab) {
        case PatientModalTabs.TIC:
            emit('displayTriageWizard', props.patient);
            return;
        case PatientModalTabs.TRANSPORT:
            emit('displayTransportWizard', props.patient);
            return;
        case PatientModalTabs.IDENTIFICATION:
            emit('displayIdentificationWizard', props.patient);
            return;
        case PatientModalTabs.HOSPITAL_RECORDS:
            emit('displayHospitalRecordsWizard', props.patient);
            return;
        default:
            emit('displayPatientModal', {
                activeTab: tab,
                patient: props.patient
            });
    }
}

const buttons = computed(() => {
    let photosLabel = pgettext('label', 'Photos');
    if (props.patient.images && props.patient.images.length > 0) {
        photosLabel += ` (${props.patient.images.length})`;
    }

    return [
        {
            condition: () => {
                return triageTabAccess(props.member.role)
            },
            tab: PatientModalTabs.TIC,
            text: pgettext('action', 'Correct Triage')
        },
        {
            condition: () => {
                return props.patient.tic && transportTabAccess(props.member.role)
            },
            tab: PatientModalTabs.TRANSPORT,
            text: pgettext('mci_label', 'Transport')
        },
        {
            condition: () => {
                return hospitalRecordsTabAccess(props.member.role)
            },
            tab: PatientModalTabs.HOSPITAL_RECORDS,
            text: pgettext('label', 'Hospital Records')
        },
        {
            condition: () => {
                return true
            },
            tab: PatientModalTabs.IDENTIFICATION,
            text: pgettext('label', 'Identification')
        },
        {
            condition: () => {
                return true
            },
            tab: PatientModalTabs.IMAGES,
            text: photosLabel,
        },
    ]
})

const activeButtons = computed(() => {
    return buttons.value.filter((item) => item.condition() === true)
})

onMounted(() => {
    if (activeButtons.value.length === 1){
        displayPatientModal(activeButtons.value[0].tab)
    }
})

</script>

<template>
    <Modal :title="title" @close="emit('close')"
           :closeOnClickOutside="false">
        <v-row>
            <v-col cols="12" class="d-flex flex-column ga-1">
                <v-btn v-for="button in activeButtons"
                       @click="displayPatientModal(button.tab)"
                       :text="button.text"
                       block
                ></v-btn>
            </v-col>
        </v-row>
    </Modal>
</template>
